import { useState, useEffect } from 'react'
import enTranslations from '../locales/en.json'
import svTranslations from '../locales/sv.json'

const translations = {
  en: enTranslations,
  sv: svTranslations,
}

const getStoreLanguage = () => {
  const user = JSON.parse(localStorage.getItem('user') || '{}')
  return user.language || 'en'
}

const useTranslation = () => {
  const [locale, setLocale] = useState(getStoreLanguage())

  // On mount, reconcile with whatever's currently in localStorage in case it
  // changed between the initial useState call and this component mounting.
  // Not a live cross-tab subscription — for that, add a `storage` listener.
  useEffect(() => {
    const next = getStoreLanguage()
    if (next !== locale) setLocale(next)
  }, [])

  // Derived from locale on every render, so setLocale(...) immediately swaps
  // the translation bundle without a stale-state window.
  const translation = translations[locale] || translations.en

  const t = (key, params) => {
    const keys = key.split('.')
    let value = translation
    keys.forEach(k => {
      value = value ? value[k] : key
    })
    if (typeof value !== 'string') return value || key
    if (params && typeof params === 'object') {
      return value.replace(/\{\{(\w+)\}\}/g, (match, name) =>
        Object.prototype.hasOwnProperty.call(params, name) ? params[name] : match
      )
    }
    return value || key
  }

  return { t, setLocale }
}

export default useTranslation